(function(){
'use strict';



/* ── Personalization toggle ── */
window.togglePersonalize = function(checkbox){
  var field = document.getElementById('bz-personalize-field');
  var input = document.getElementById('bz-personalize-input');
  if(!field) return;
  if(checkbox.checked){
    field.style.display = 'block';
    if(input) input.focus();
  } else {
    field.style.display = 'none';
    if(input){ input.value = ''; updateCharCount(input); }
  }
};

window.updateCharCount = function(input){
  var count = document.getElementById('bz-char-count');
  if(count) count.textContent = input.value.length + '/14';
  if(input.value.length >= 14){
    count.style.color = '#a07d3a';
  } else {
    count.style.color = '#aaa';
  }
};

window.addEventListener('DOMContentLoaded', function(){


  /* Accordion */
  document.querySelectorAll('.bz-acc-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var content = this.nextElementSibling;
      var icon = this.querySelector('.bz-acc-icon');
      var isOpen = content && content.classList.contains('open');
      document.querySelectorAll('.bz-acc-content.open').forEach(function(c){
        c.classList.remove('open');
        var i = c.previousElementSibling && c.previousElementSibling.querySelector('.bz-acc-icon');
        if(i) i.textContent = '+';
      });
      if(!isOpen && content){ content.classList.add('open'); if(icon) icon.textContent = '−'; }
    });
  });

  /* View more reviews */
  var moreBtn = document.getElementById('bz-view-more');
  var moreSection = document.getElementById('bz-reviews-more');
  if(moreBtn && moreSection){
    moreBtn.addEventListener('click', function(){
      moreSection.style.display = 'block';
      moreBtn.style.display = 'none';
    });
  }

});
})();
